
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthProvider } from '../services/auth.provider';

@Injectable({providedIn: 'root'})
export class ArchiveGuard  {

  constructor(private auth: AuthProvider, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.auth.isAuthenticated()) {
      if (!!this.auth.hasAccessToPdf() || !!this.auth.hasAccessTo()) {
        return true;
      } else {
        this.router.navigate(['conexion']);
      }
    } else {
      if (this.auth.logedWithNoProfiles()) {
        this.router.navigate(['creer-compte', 'etape-2']);
      } else if (this.auth.isPartiallyAuthenticated()) {
        this.router.navigate(['profiles']);
      } else {
        this.router.navigate(['connexion']);
      }
    }

    return false;
  }
}
